// Copyright (c) 2020 Deere & Company

import './app-header.scss';
import { Link, withRouter } from 'react-router-dom';
import AppGreeting from './app-greeting';
import AppLogo from './app-logo';
import AppNavigation from './app-navigation';
import AuthenticatedPage from '../authenticated-page';
import React from 'react';

export const AppHeader = () => {

    const location = window.location.href;
    let page = '';
    if ( location.indexOf( '/atp-setup' ) !== -1 ) page = 'atp-setup';
    if ( location.indexOf( '/reping' ) !== -1 ) page = 'reping';
    return (
        <div>
            <div className="app-header">
                <div className="confidential-logo-group">
                    <AppLogo />
                </div>
                <div className="app-title-section">
                    <div className="title-and-greeting">
                        <h1 className="app-title">
                            {page === '' && (
                                <Link className="app-link" to="/units">
                            Available to Promise
                                </Link>
                            )}
                            {page === 'atp-setup' && (
                                <Link className="app-link" to="/atp-setup">
                            ATP Setup
                                </Link>
                            )}
                            {page === 'reping' && (
                                <Link className="app-link" to="/reping">
                            Reping
                                </Link>
                            )}
                            {page === 'auditlog' && (
                                <Link className="app-link" to="/auditlog">
                            AuditLog
                                </Link>
                            )}
                        </h1>
                        <AppGreeting />
                    </div>
                </div>
            </div>
            <AuthenticatedPage>
                <AppNavigation />
            </AuthenticatedPage>
        </div>
    );

};

export default withRouter( AppHeader );
